"use client";
import Link from 'next/link';
import OpeningSearch from './OpeningsSearch';
import OpeningList from './OpeningsList';
import styles from './styles.module.scss';
import { useState, useEffect} from 'react';

const Openings = props => {
    const {headline} = props || {};
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({location: '', department: ''});
    const [jobs, setJobs] = useState([]);

    const handleJobsAlertClick = e => {
        console.log(e);
    }
    useEffect(() => {
        const fetchJobs = async () => {
          try {
            const response = await fetch('/api/careers', {
                method: 'GET',
                headers: {
                    'Cache-Control': 'no-cache', // Prevent caching on the client-side
                },
                cache: 'no-store', // Bypass the fetch cache
            });

            if (!response.ok) {
                
              throw new Error('Failed to fetch jobs');
            }
            const data = await response.json();
            setJobs(data);
          } catch (error) {
            console.error('Error fetching jobs:', error);
          }
        };
    
        fetchJobs();
    }, []);


    const renderHeadline = () => {
        if(!headline) return null;
        return (
            <h2 className={styles.openings__title}>
                {headline}
            </h2>
        );
    }
    return (
        <>
            {/* <Script
                id="sr-jsplugins"
                src="https://subscriptions.smartrecruiters.com/widget/v1/sr-job-alerts.js?dcr_ci=Daxko1"
                strategy="lazyOnload"
            />
            <div
                id="sr-plugins"
                data-configuration-id="E3FD539D-00CC-485C-9C68-32B588AAEC10"
                data-bg="ED145B"
                data-width="152"
                data-font-size="2rem"
                data-lang=""
                data-company-identifier="Daxko1"
                data-style="border-radius: 15px;"
            ></div> */}
            <section className={styles.openings} id="openingsRef">
            <div className="container">
                <div className={styles.openings__inner}>
                    {renderHeadline()}
                    <OpeningSearch jobs={jobs} setSearch={setSearch} setFilters={setFilters}/>
                    <OpeningList jobs={jobs} search={search} filters={filters}/>
                    <div>
                        <p className={styles.openings__blurb}> 
                            {`Don't see the right fit right now? Create a job alert to be notified when new positions are available.`}
                        </p>
                    </div>
                    <div className={styles.openings__ctaRow}>
                        <Link href={`https://www.gem.com/form?formID=4394acb8-174b-4779-b13c-a309b53ef7a4`} target={`_blank`} className='button transparent-fill large'>
                            {`Join the Daxko talent community`}
                        </Link>
                        {/* <Link href={`#`} id="sr-alert-button" className={`${styles.openings__notifyButton}`}>
                            {`Notify me of Jobs`}
                        </Link> */}
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default Openings;